<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12>
      <div class="section-header" row wrap align-content-center justify-center>
        <h1 class="section-title">
          <v-icon color="deep-orange darken-2">fal fa-dumbbell</v-icon>
          Treinos
        </h1>
      </div>
    </v-flex>
    <new-training :saveIntoModel="true"></new-training>
  </v-layout>
</template>

<script>
// import axios from 'axios'
// import router from '@/router'
// import EventBus from '@/event-bus'
import NewTrainingComponent from '@/components/admin/trainings/NewTrainingComponent'

export default {
  components: {
    'new-training': NewTrainingComponent
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/trainings/AdminNewTraining.vue